import { createMuiTheme } from '@material-ui/core/styles';

/** @deprecated */
export default createMuiTheme;
